module.exports = __webpack_public_path__ + "img/box-packaging@1x.b613ad91.png";